module.exports = __webpack_public_path__ + "img/s2_stepimg01.c28a5b91.png";